<div class="account-dialog">
    <div class="seperator"></div>
    <div class="title" mat-dialog-title>Reset password</div>
    <div class="dialog-body{{sent?' emailsent-body':''}}">
        <form *ngIf="sent===false" class="forget-password-form" [formGroup]="resetForm">
            <div class="form-text">Enter your new password</div>
            <mat-form-field class="form-field">
                <input type="password" matInput placeholder="Password" formControlName="password">
                <mat-error *ngIf="resetForm.get('password').errors && (resetForm.get('password').touched || resetForm.get('password').dirty)">
                    Please enter a valid password
                </mat-error>
            </mat-form-field>
            <div class="password-tips">
                <div class="text-gap">Your password needs to contain at least:</div>

                    <ul type="disc">
                        <li>8 characters</li>
                        <li>1 lowercase & 1 uppercase letter</li>
                        <li>1 number</li>
                    </ul>


            </div>
            <mat-form-field class="form-field">
                <input type="password" matInput placeholder="Repeat password" formControlName="repeat">
                <mat-error *ngIf="resetForm.get('repeat').errors  && (resetForm.get('repeat').touched || resetForm.get('repeat').dirty)">
                    Please enter a valid repeat password
                </mat-error>
            </mat-form-field>
            <div class="form-field" class="mismatch-error">
                <mat-error *ngIf="resetForm.get('password').errors === null && resetForm.get('repeat').errors === null && !resetForm.valid">
                    Password and repeat password <strong>doesn't match</strong>
                </mat-error>
            </div>
            <button mat-raised-button (click)="reset()" class="rubii-btn reset-button" color="primary">Reset password</button>
        </form>
        <ng-container *ngIf="sent">
            <div>Your password has been reset. You can now try logging in with your new password.</div>
            <mat-dialog-actions align="center">
                <button mat-raised-button mat-dialog-close class="rubii-btn gotologin-button" color="primary">Go to login</button>
            </mat-dialog-actions>
        </ng-container>
    </div>
</div>